// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type StorageAndIoQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
}>;

export type StorageAndIoQuery = {
  __typename?: "GraphqlQuery";
  getSystemStats?: {
    __typename?: "SystemStatsSeries";
    id: string;
    storageSpaceTotal?: Array<Array<number | null> | null> | null;
    storageSpaceFree?: Array<Array<number | null> | null> | null;
    storageSpaceUsed?: Array<Array<number | null> | null> | null;
    storageIopsRead?: Array<Array<number | null> | null> | null;
    storageIopsWrite?: Array<Array<number | null> | null> | null;
    storageLatencyRead?: Array<Array<number | null> | null> | null;
    storageLatencyWrite?: Array<Array<number | null> | null> | null;
    storageThroughputRead?: Array<Array<number | null> | null> | null;
    storageThroughputWrite?: Array<Array<number | null> | null> | null;
    storageUtilization?: Array<Array<number | null> | null> | null;
    storageUtilizationPct90?: Array<Array<number | null> | null> | null;
    storageUtilizationPct100?: Array<Array<number | null> | null> | null;
    storageQueueDepth?: Array<Array<number | null> | null> | null;
  } | null;
  getServerDetails: {
    __typename?: "Server";
    id: string;
    lastSnapshot?: { __typename?: "Snapshot"; collectorVersion: number } | null;
  };
};

export const StorageAndIoDocument = gql`
  query StorageAndIO($serverId: ID!, $startTs: Int!, $endTs: Int!) {
    getSystemStats(serverId: $serverId, startTs: $startTs, endTs: $endTs) {
      id
      storageSpaceTotal
      storageSpaceFree
      storageSpaceUsed
      storageIopsRead
      storageIopsWrite
      storageLatencyRead
      storageLatencyWrite
      storageThroughputRead
      storageThroughputWrite
      storageUtilization
      storageUtilizationPct90
      storageUtilizationPct100
      storageQueueDepth
    }
    getServerDetails(serverId: $serverId) {
      id
      lastSnapshot {
        collectorVersion
      }
    }
  }
`;

/**
 * __useStorageAndIoQuery__
 *
 * To run a query within a React component, call `useStorageAndIoQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorageAndIoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorageAndIoQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *   },
 * });
 */
export function useStorageAndIoQuery(
  baseOptions: Apollo.QueryHookOptions<
    StorageAndIoQuery,
    StorageAndIoQueryVariables
  > &
    (
      | { variables: StorageAndIoQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StorageAndIoQuery, StorageAndIoQueryVariables>(
    StorageAndIoDocument,
    options,
  );
}
export function useStorageAndIoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StorageAndIoQuery,
    StorageAndIoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StorageAndIoQuery, StorageAndIoQueryVariables>(
    StorageAndIoDocument,
    options,
  );
}
// @ts-ignore
export function useStorageAndIoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    StorageAndIoQuery,
    StorageAndIoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<StorageAndIoQuery, StorageAndIoQueryVariables>;
export function useStorageAndIoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StorageAndIoQuery,
        StorageAndIoQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  StorageAndIoQuery | undefined,
  StorageAndIoQueryVariables
>;
export function useStorageAndIoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StorageAndIoQuery,
        StorageAndIoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<StorageAndIoQuery, StorageAndIoQueryVariables>(
    StorageAndIoDocument,
    options,
  );
}
export type StorageAndIoQueryHookResult = ReturnType<
  typeof useStorageAndIoQuery
>;
export type StorageAndIoLazyQueryHookResult = ReturnType<
  typeof useStorageAndIoLazyQuery
>;
export type StorageAndIoSuspenseQueryHookResult = ReturnType<
  typeof useStorageAndIoSuspenseQuery
>;
export type StorageAndIoQueryResult = Apollo.QueryResult<
  StorageAndIoQuery,
  StorageAndIoQueryVariables
>;
